import classNames from 'classnames';
import T from '../../../../common/components/T';
import { dataSender, getData, navigateV2 } from '../../../../common/utils/router';
import { Portal, svgSprite } from '../../../../hybrid/wrappers';
import Skeleton from '../../../../widgets/plug/Skeleton/Skeleton';
import css from './InfoBlock.module.scss';
import { getProlongationInfo, skeleton } from './helpers';
import { useContext, useEffect, useMemo, useState } from 'react';
import UserContext, { UserProfileContext } from '../../../../common/utils/getContext';
import moment from 'moment';
import Notification from '../../../../widgets/notification/Notification';
import { API_SERVER_URL, getDaysLabel } from '../../../../common/utils/utils';

const ProlongationModal = ({ closeHandler }) => {
    return (
        <Portal closeHandler={closeHandler}>
            <div className={css.modal}>
                <div onClick={closeHandler} className={classNames('circleButton', css.modalClose)}>
                    {svgSprite('cross', { className: css.modalCloseSvg })}
                </div>
                <div className={css.modalText}>
                    <p>
                        <T
                            vars={{ needed: 100 }}
                            textName='prolongation-modal-text-1'
                            defaultStr='Для пролонгации аккаунта необходимо приобрести продукции в магазине на ${needed} PV или больше, разово. С не пролонгированным аккаунтом, вознаграждения, кроме Recruiting bonus, не начисляются, а средства на бонусном кошельке будут недоступны к выводу.'
                            page='/office'
                        />
                    </p>
                    <p>
                        <T
                            textName='prolongation-modal-text-2'
                            defaultStr='Освобождение от пролонгации, если Вы сделали накопительно оплат заказов на сумму, меньше 200 PV но при этом получил вознаграждений за аналогичный период менее 1000 PV, также если это ваш первый год участия в маркетинге, Вы можете быть освобождены от пролонгации.'
                            page='/office'
                        />
                    </p>
                </div>
            </div>
        </Portal>
    );
};

const RenderData = (props) => {
    const { verification, activity, profileData, profile, currentEducationNotification } = props;
    const { time } = useContext(UserContext);
    const [prolongationModal, showProlongationModal] = useState(false);
    const prolongCondition = activity?.data?.conditions?.prolong;
    const prolongationInfo = useMemo(() => getProlongationInfo(prolongCondition, activity), [prolongCondition, activity]);
    const isBirthday = moment(profile?.birthdate, 'YYYY-MM-DD').format('DD-MM') === time().format('DD-MM');

    // const daysToConfirmRank = useMemo(() => {
    //     if (profileData?.marketing_profile?.confirm_rank_info) {
    //         return moment(profileData?.marketing_profile?.confirm_rank_info?.date, 'DD.MM.YYYY HH:ss').diff(time(), 'days');
    //     }
    //     return '';
    // }, [time, profileData]);

    if (
        verification?.data?.status?.value !== 'not_verified' &&
        verification?.data?.status?.value !== 'rejected' &&
        !prolongationInfo?.title &&
        !prolongationInfo?.description &&
        !isBirthday &&
        !profileData?.marketing_profile?.confirm_rank_info &&
        !currentEducationNotification &&
        !profileData?.can_give_gift &&
        !profileData?.gift_account?.gift_info?.date
    )
        return null;
    return (
        <>
            <div className={css.wrapper}>
                {/*{profile?.verification_message ? (*/}
                {/*    <>*/}
                {/*        <Notification*/}
                {/*            icon='warning-rhombus'*/}
                {/*            description={*/}
                {/*                <T textName='kz_ie_message' defaultStr='Требуется пройти верификацию как юридическое лицо' />*/}
                {/*            }*/}
                {/*            buttonText={<T textName='pass-verification' defaultStr='Пройти верификацию' page='/office' />}*/}
                {/*            buttonFunc={() => navigateV2('/profile#verification')}*/}
                {/*            customCss={{ icon: css.notifyIcon }}*/}
                {/*        />*/}
                {/*    </>*/}
                {/*) : null}*/}

                {/* {profileData?.can_give_gift ? (
                    <Notification
                        icon='warning-rhombus'
                        title={
                            <T
                                textName='notification_can_give_gift'
                                defaultStr='Получите единоразовые подарочные баллы до 31 августа!'
                                page='/office'
                            />
                        }
                        description={
                            <div>
                                <ul style={{ 'padding-left': '20px' }}>
                                    <li>
                                        <T
                                            textName='notification_can_give_gift1'
                                            defaultStr='При оформите заказ от 100 до 199 PV получите бонус 20 PV.'
                                            page='/office'
                                        />
                                    </li>
                                    <li>
                                        <T
                                            textName='notification_can_give_gift2'
                                            defaultStr=' При оформлении от 200 PV — получите максимальный подарок 50 PV'
                                            page='/office'
                                        />
                                    </li>
                                </ul>
                            </div>
                        }
                        buttonText={<T textName='go-store' defaultStr='Перейти в магазин' page='/office' />}
                        buttonFunc={() => navigateV2('/store')}
                        customCss={{ icon: css.notifyIcon }}
                    />
                ) : null} */}
                {profileData?.gift_account?.gift_info?.date ? (
                    <Notification
                        icon='warning-rhombus'
                        title={
                            <T
                                textName='notification_gift_have'
                                vars={{
                                    date: moment(profileData?.gift_account?.gift_info?.date).format('DD.MM.YYYY'),
                                    balance: profileData?.gift_account?.formatted_balance
                                }}
                                defaultStr='У Вас есть подарочные ${balance}. Их можно использовать в магазине до ${date}.'
                                page='/office'
                            />
                        }
                        buttonText={<T textName='go-store' defaultStr='Перейти в магазин' page='/office' />}
                        buttonFunc={() => navigateV2('/store')}
                        customCss={{ icon: css.notifyIcon }}
                    />
                ) : null}
                {profileData?.marketing_profile?.confirm_rank_info && !!profileData?.marketing_profile?.activity ? (
                    <Notification
                        icon='warning-rhombus'
                        title={
                            <>
                                {profileData?.marketing_profile?.confirm_rank_info?.rank?.sort === 9 ? (
                                    <>
                                        <span>
                                            <T
                                                vars={{
                                                    rank: profileData?.marketing_profile?.confirm_rank_info?.rank?.name,
                                                    amount: profileData?.marketing_profile?.confirm_rank_info?.amount
                                                }}
                                                textName='rank-not-confirmed-v1'
                                                defaultStr='Квалификация ${rank} или выше предусматривает единоразовое подтверждение статуса путем совершения заказа на ${amount} PV'
                                                page='/office'
                                            />
                                            .
                                        </span>
                                        {/* <span style={{ display: 'block' }}>
                                            <T textName='rank-not-confirmed-time-to-left' defaultStr='Осталось' page='/office' />
                                            {` ${daysToConfirmRank} `}
                                            {getDaysLabel(+daysToConfirmRank)}.
                                        </span> */}
                                    </>
                                ) : (
                                    <>
                                        <span>
                                            <T
                                                vars={{
                                                    rank: profileData?.marketing_profile?.confirm_rank_info?.rank?.name,
                                                    amount: profileData?.marketing_profile?.confirm_rank_info?.amount
                                                }}
                                                textName='rank-not-confirmed-v2'
                                                defaultStr='Квалификация ${rank} предусматривает единоразовое подтверждение статуса путем совершения заказа на ${amount} PV'
                                                page='/office'
                                            />
                                            .
                                        </span>
                                        {/* <span style={{ display: 'block' }}>
                                            <T textName='rank-not-confirmed-time-to-left' defaultStr='Осталось' page='/office' />
                                            {` ${daysToConfirmRank} `}
                                            {getDaysLabel(+daysToConfirmRank)}.
                                        </span> */}
                                    </>
                                )}
                            </>
                        }
                        buttonText={<T textName='go-store' defaultStr='Перейти в магазин' page='/office' />}
                        buttonFunc={() => navigateV2('/store')}
                        customCss={{ icon: css.notifyIcon }}
                    />
                ) : null}
                {verification?.data?.status?.value === 'not_verified' || verification?.data?.status?.value === 'rejected' ? (
                    <Notification
                        icon='warning-rhombus'
                        title={<T textName='verification-not-passed' defaultStr='Верификация не пройдена' page='/office' />}
                        description={
                            <>
                                <T
                                    textName='to-withdraw-money-you-need-get-verification'
                                    defaultStr='Для вывода средств необходимо пройти верификацию'
                                    page='/office'
                                />
                                .
                            </>
                        }
                        buttonText={<T textName='pass-verification' defaultStr='Пройти верификацию' page='/office' />}
                        buttonFunc={() => navigateV2('/profile#verification')}
                        customCss={{ icon: css.notifyIcon }}
                    />
                ) : null}
                {prolongCondition?.days <= 60 && !activity?.data?.conditions?.prolong?.need_prolong ? (
                    <Notification
                        icon='warning-rhombus'
                        title={
                            <T
                                vars={{ days: prolongCondition?.days, dayLabel: getDaysLabel(prolongCondition?.days) }}
                                textName='prolongation-info-title-1'
                                defaultStr='До проверки пролонгации аккаунта осталось: ${days} ${dayLabel}.'
                                page='/office'
                            />
                        }
                        description={
                            <T
                                textName='prolongation-info-description-1'
                                defaultStr='Для пролонгации необходимо произвести покупку на 100 PV или более.'
                                page='/office'
                            />
                        }
                        buttonFunc={() => navigateV2('/store')}
                        buttonText={<T textName='moreDetails' defaultStr='Перейти в магазин' page='/office' />}
                        customCss={{ icon: css.notifyIcon }}
                    />
                ) : null}
                {!Array.isArray(prolongCondition) &&
                prolongCondition?.days <= 60 &&
                activity?.data?.activity &&
                (prolongationInfo?.title || prolongationInfo?.description) ? (
                    <>
                        <Notification
                            icon='warning-rhombus'
                            title={prolongationInfo?.title}
                            description={prolongationInfo?.description}
                            buttonFunc={() => navigateV2('/store')}
                            buttonText={<T textName='moreDetails' defaultStr='Перейти в магазин' page='/office' />}
                            customCss={{ icon: css.notifyIcon }}
                        />
                    </>
                ) : !Array.isArray(prolongCondition) &&
                  prolongCondition?.days <= 60 &&
                  !activity?.data?.activity &&
                  (prolongationInfo?.title || prolongationInfo?.description) ? (
                    <>
                        <Notification
                            icon='warning-rhombus'
                            title={prolongationInfo?.title}
                            description={prolongationInfo?.description}
                            buttonFunc={() => navigateV2('/store')}
                            buttonText={<T textName='moreDetails' defaultStr='Перейти в магазин' page='/office' />}
                            customCss={{ icon: css.notifyIcon }}
                        />
                    </>
                ) : !Array.isArray(prolongCondition) && activity?.data?.conditions?.prolong?.need_prolong ? (
                    <>
                        <Notification
                            icon='warning-rhombus'
                            title={prolongationInfo?.title}
                            description={prolongationInfo?.description}
                            buttonFunc={() => navigateV2('/store')}
                            buttonText={<T textName='moreDetails' defaultStr='Перейти в магазин' page='/office' />}
                            customCss={{ icon: css.notifyIcon }}
                        />
                    </>
                ) : !Array.isArray(prolongCondition) &&
                  !activity?.data?.conditions?.prolong?.need_prolong &&
                  !activity?.data?.activity ? (
                    <>
                        <Notification
                            icon='warning-rhombus'
                            title={prolongationInfo?.title}
                            description={prolongationInfo?.description}
                            buttonFunc={() => navigateV2('/store')}
                            buttonText={<T textName='moreDetails' defaultStr='Перейти в магазин' page='/office' />}
                            customCss={{ icon: css.notifyIcon }}
                        />
                    </>
                ) : null}
                {isBirthday ? (
                    <Notification
                        customCss={{
                            icon: css.heartIcon
                        }}
                        icon='heart-fill'
                        title={
                            <>
                                <T
                                    vars={{ name: profileData?.full_name }}
                                    textName='office-info-birthday-alert-title'
                                    defaultStr='С Днем Рождения, ${name}'
                                    page='/office'
                                />
                                !
                            </>
                        }
                        description={
                            <>
                                <T
                                    textName='office-info-birthday-alert-description'
                                    defaultStr='Пусть этот год будет для Вас самым успешным'
                                    page='/office'
                                />
                                !
                            </>
                        }
                    />
                ) : null}
                {currentEducationNotification ? (
                    <Notification
                        title={currentEducationNotification?.message}
                        icon={'book'}
                        customCss={{ icon: css.lessonIcon }}
                        buttonFunc={() => {
                            const courseId = currentEducationNotification?.course_link?.split('/courses/')[1];
                            if (courseId) {
                                navigateV2(`/education/course/learning/${courseId}`);
                            }
                        }}
                        buttonText={<T textName='go-to' defaultStr='Перейти' />}
                    />
                ) : null}
            </div>
            {prolongationModal ? (
                <ProlongationModal prolongCondition={prolongCondition} closeHandler={() => showProlongationModal(false)} />
            ) : null}
        </>
    );
};

export default function InfoBlock(props) {
    const { userToken, lang } = useContext(UserContext);
    const { profileData } = useContext(UserProfileContext);
    const [profile, setProfile] = useState(null);
    // повідомлення про навчання
    const [educationNotifications, setEducationNotifications] = useState(null);

    const [currentEducationNotification, setCurrentEducationNotification] = useState(null);

    useEffect(() => {
        let i = 0;
        let currentNotification = educationNotifications?.[i];
        if (educationNotifications?.length) {
            setCurrentEducationNotification(currentNotification);
            let interval = setInterval(() => {
                dataSender(
                    `${API_SERVER_URL}/api/v1/user/education/notifications/set-notified`,
                    'POST',
                    {
                        part_type: currentNotification.part_type,
                        part_id: currentNotification.part_id
                    },
                    () => {
                        if (educationNotifications[i + 1]) {
                            setCurrentEducationNotification(educationNotifications[i + 1]);
                            currentNotification = educationNotifications[i + 1];
                            i += 1;
                        } else {
                            setCurrentEducationNotification(null);
                            clearInterval(interval);
                        }
                    },
                    () => {
                        if (educationNotifications[i + 1]) {
                            setCurrentEducationNotification(educationNotifications[i + 1]);
                            currentNotification = educationNotifications[i + 1];
                            i += 1;
                        } else {
                            setCurrentEducationNotification(null);
                            clearInterval(interval);
                        }
                    },
                    userToken,
                    lang
                );
            }, 15 * 1000);
            return () => {
                dataSender(
                    `${API_SERVER_URL}/api/v1/user/education/notifications/set-notified`,
                    'POST',
                    {
                        part_type: currentNotification.part_type,
                        part_id: currentNotification.part_id
                    },
                    () => {},
                    () => {},
                    userToken,
                    lang
                );
                clearInterval(interval);
            };
        }
    }, [educationNotifications, userToken, lang]);

    useEffect(() => {
        getData('/api/v1/user/education/notifications?page[size]=25', userToken, lang).then((res) => {
            if (res?.data) {
                setEducationNotifications(res?.data);
            }
        });
    }, [userToken, lang]);

    useEffect(() => {
        getData('/api/v1/user/profile', userToken, lang).then((res) => {
            if (res?.data) {
                setProfile(res.data);
            }
        });
    }, [userToken, lang]);

    const { verification, activity } = props;
    return (
        <Skeleton
            Component={RenderData}
            wait={Boolean(verification) && Boolean(activity) && Boolean(profileData)}
            wrapperStyles={css.skeleton}
            pattern={skeleton}
            componentProps={{
                verification,
                activity,
                profileData,
                profile,
                currentEducationNotification
            }}
        />
    );
}
